module.exports = __webpack_public_path__ + "img/mail_ill.e2222a43.svg";